import * as React from 'react';
import { ReportInstitutionGroupView } from 'cb-model';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useCloneEntity,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { ReportMenu } from './ReportMenu';
import { useSetMaxWeekCommencing } from './useSetMaxWeekCommencing';

export const GroupWeekSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(ReportInstitutionGroupView);
  useSetMaxWeekCommencing(queryOptions, setQueryOptions);
  const LocalReportInstitutionGroupView = useCloneEntity(ReportInstitutionGroupView, (clone) => {
    clone.fields.institution_group_id.listColumn = true;
    clone.fields.week_commencing.listColumn = true;
    // clone.fields.user_id.listColumn = true;
  });
  const gCacheQueryItem = useCacheQuery(ReportInstitutionGroupView, queryOptions);
  return (
    <>
      <PageTitle title="Group / Week Report" />
      <ReportMenu />
      <Section>
        <p>
          Events, Bookings and Attendance per Group per Week, for Events that belong to each Group. Bookings and
          Attendance data includes Users who do not belong to the Group, if that is allowed, hence may show more
          Bookings than the click-through.
        </p>
        <PaginatorAndListSettings
          entity={LocalReportInstitutionGroupView}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
